import { Clock, AlertTriangle } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';

const priorityColor = (p) => {
  switch (p) {
    case 'P1': return { bg: 'bg-red-500/15', text: 'text-red-300', border: 'border-red-500/30' };
    case 'P2': return { bg: 'bg-amber-500/15', text: 'text-amber-200', border: 'border-amber-500/30' };
    case 'P3': return { bg: 'bg-indigo-500/15', text: 'text-indigo-200', border: 'border-indigo-500/30' };
    default: return { bg: 'bg-slate-500/15', text: 'text-slate-300', border: 'border-slate-500/30' };
  }
};

const urgencyColor = (minutes) => {
  if (minutes < 30) return 'text-[var(--nexus-danger)]';
  if (minutes < 120) return 'text-[var(--nexus-warning)]';
  return 'text-[var(--nexus-text-secondary)]';
};

const formatMinutes = (m) => {
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return `${h}h ${rm}m`;
};

export const SlaBurnWidget = ({ entries }) => {
  return (
    <div data-testid="sla-burn-widget" className="nexus-card relative overflow-hidden">
      <div className="p-3 border-b border-[var(--nexus-border)]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock size={14} className="text-[var(--nexus-warning)]" />
            <h2 className="text-sm font-semibold text-[var(--nexus-text-primary)] tracking-wide">SLA Burn Rate</h2>
          </div>
          <span className="font-mono text-[10px] font-bold px-1.5 py-0.5 rounded-md bg-[#4d3000] text-[#fcd34d] border border-amber-500/30">
            {entries.filter(e => e.sla_remaining_minutes < 60).length} AT RISK
          </span>
        </div>
      </div>
      <ScrollArea className="h-[200px]">
        <div className="p-2 flex flex-col gap-1.5">
          {entries.map((entry) => {
            const pc = priorityColor(entry.priority);
            return (
              <div
                key={entry.ticket_id}
                className="flex items-center gap-2 p-2 rounded-lg bg-[var(--nexus-bg-base)] border border-[var(--nexus-border)]"
              >
                <span className={`font-mono text-[10px] px-1.5 py-0.5 rounded ${pc.bg} ${pc.text} border ${pc.border}`}>
                  {entry.priority}
                </span>
                <div className="flex-1 min-w-0">
                  <span className="font-mono text-[10px] text-[var(--nexus-primary-bright)]">{entry.ticket_id}</span>
                  <p className="text-[10px] text-[var(--nexus-text-muted)] truncate">{entry.title}</p>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  {entry.sla_remaining_minutes < 60 && <AlertTriangle size={10} className="text-[var(--nexus-danger)]" />}
                  <span className={`font-mono text-[10px] tabular-nums ${urgencyColor(entry.sla_remaining_minutes)}`}>
                    {formatMinutes(entry.sla_remaining_minutes)}
                  </span>
                </div>
              </div>
            );
          })}
          {entries.length === 0 && (
            <div className="text-center py-4 text-[var(--nexus-text-muted)] text-xs">No SLA burn alerts</div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
